export default __webpack_public_path__ + "a7727ce41cea33f9d7150a858e2a9bb3.svg";